// Paths where a user must not be tracked, for privacy and legal reasons.
const UNTRACKABLE_PATHS = ['/'];

// Routes where a user must not be tracked, including every route beneath them.
const UNTRACKABLE_ROUTES = ['/corporate-pages'];

const isUntrackablePath = (pathname: string | null | undefined): boolean => {
  const trimmed = (pathname ?? '').replace(/\/+$/, '');
  // Stripping the trailing slash leaves the home page as an empty string.
  const path = trimmed === '' ? '/' : trimmed;

  if (UNTRACKABLE_PATHS.includes(path)) return true;

  return UNTRACKABLE_ROUTES.some(
    (route) => path === route || path.startsWith(`${route}/`),
  );
};

export default isUntrackablePath;
